"use client";

import { useState, useRef, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import EventForm from "../event_components/EventForm";
import {useNavigate} from "react-router-dom";
import {isAuthenticated} from "../../utils/helpers";

const HorizontalScrollList = () => {
  const navigate=useNavigate()
  const [showForm, setShowForm] = useState(false);
  const scrollContainerRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  // Check scroll buttons on mount and when window resizes
  useEffect(() => {
    checkScrollButtons();
    window.addEventListener("resize", checkScrollButtons);
    return () => window.removeEventListener("resize", checkScrollButtons);
  }, []);

  const checkScrollButtons = () => {
    if (!scrollContainerRef.current) return;

    const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 10); // 10px buffer
  };

  const scroll = direction => {
    if (!scrollContainerRef.current) return;

    const container = scrollContainerRef.current;
    const scrollAmount = container.clientWidth * 0.8;

    container.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth"
    });
  };

  return (
    <div className="relative w-full max-w-6xl mx-auto">
      {/* Scroll buttons */}
      <button
        className={`absolute left-2 top-1/2 -translate-y-1/2 z-10 rounded-full bg-white p-2 shadow-md ${
          !canScrollLeft ? "opacity-0 pointer-events-none" : ""
        }`}
        onClick={() => scroll("left")}
        aria-hidden={!canScrollLeft}
      >
        <ChevronLeft className="h-6 w-6" />
        <span className="sr-only">Scroll left</span>
      </button>

      <button
        className={`absolute right-2 top-1/2 -translate-y-1/2 z-10 rounded-full bg-white p-2 shadow-md ${
          !canScrollRight ? "opacity-0 pointer-events-none" : ""
        }`}
        onClick={() => scroll("right")}
        aria-hidden={!canScrollRight}
      >
        <ChevronRight className="h-6 w-6" />
        <span className="sr-only">Scroll right</span>
      </button>

      {/* Scrollable container */}
      <div
        ref={scrollContainerRef}
        className="flex overflow-x-auto snap-x snap-mandatory gap-2 py-2 px-4"
        style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
        onScroll={checkScrollButtons}
      >
        {/* Image 1 */}
        <div className="flex-none w-120 snap-center">
          <div className="rounded-lg overflow-hidden h-64">
            <img
              src="/images/image0.webp"
              alt="VR headset promotional image showing virtual reality experience"
              className="w-full h-full object-contain"
              onClick={() => {
                if (isAuthenticated()) {
                  setShowForm(true);
                } else {
                  localStorage.setItem("target", window.location.pathname);
                  navigate("/signin");
                }
              }}
            />
          </div>
        </div>
      </div>
      {showForm && <EventForm onClose={() => setShowForm(false)} pe={true} />}
    </div>
  );
};

export default HorizontalScrollList;
